import { render, staticRenderFns } from "./CustomerAddressForm.vue?vue&type=template&id=080d5d61&scoped=true&"
import script from "./CustomerAddressForm.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddressForm.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerAddressForm.vue?vue&type=style&index=0&id=080d5d61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d5d61",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
